import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "Introduction to Data Science (Data Types, Visualization, Statistical Analysis)",
  "Data Visualization (Tableau, Power BI, Geospatial Visualization)",
  "Machine Learning (Supervised, Unsupervised, Deep Learning)",
  "Big Data (Hadoop, Spark, NoSQL)",
  "Statistical Analysis & Predictive Analytics",
  "Deep Learning (CNNs, RNNs, GANs, Transfer Learning)",
  "Data Science Tools (Python, R, SQL, Tableau, Power BI)",
  "Applications (Predictive Modeling, Recommendation Systems)",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const DataScienceandAnalyst = () => (
  <CourseDetailTemplate title="Data Science and Analyst Course"
    description="Transform data into insights! Master data visualization, statistical analysis, machine learning, and data wrangling. Develop the expertise to analyse trends and drive data-driven decisions."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["Python", "R", "SQL", "Tableau", "Power BI", "Machine Learning"]}
    programName="Data Science and Analyst Course"
  />
);
export default DataScienceandAnalyst;
